import { render, staticRenderFns } from "./piece-rate-salary.vue?vue&type=template&id=2c8562e8&scoped=true&"
import script from "./piece-rate-salary.vue?vue&type=script&lang=js&"
export * from "./piece-rate-salary.vue?vue&type=script&lang=js&"
import style0 from "./piece-rate-salary.vue?vue&type=style&index=0&id=2c8562e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8562e8",
  null
  
)

export default component.exports